export const FRENCHISES_ITEM_SALE_REPORT_ACTION = 'FRENCHISES_ITEM_SALE_REPORT_ACTION'
export const FRENCHISES_ITEM_SALE_REPORT_ACTION_SUCCESS = 'FRENCHISES_ITEM_SALE_REPORT_ACTION_SUCCESS'
export const FRENCHISES_ITEM_SALE_REPORT_ERROR_ACTION = 'FRENCHISES_ITEM_SALE_REPORT_ERROR_ACTION'

